const rodzaj = { t: 'Rodzaj', name: 'kategoria', hint: { url: '/tool_category' }}
export default rodzaj